module.exports = __webpack_public_path__ + "images/building-names-8016adde67b38e806e586aab7d9ddbd0.jpg";